import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Portlet, Col, Row, Button, Form } from '_zari/core'

import { IdGen } from 'utils'

import * as PresupuestoService from 'services/presupuesto.service'

import * as FormGroups from './formGroups'
import * as Tables from './tables'
import ValidationSchema from './validation'

import './index.scss'

const portletBreadcrumbs = [{ name: 'Presupuestos-Asignacion' }]

const MainPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const [presupuestosDatos, setPresupuestosDatos] = React.useState([])
  const [__keyTabla, setKeyTabla] = React.useState(IdGen.newId())

  const formikRef = React.useRef(null)

  const formInitialValues = React.useMemo(() => {
    const anioActual = new Date().getFullYear()

    return {
      _idProyecto: '',
      moneda: '',
      datoPresupuestoNivel1: '',
      anoDesde: anioActual
    }
  }, [])

  const onSubmit = React.useCallback(
    (formData, { setSubmitting }) => {
      __zariContext.loader.open('Cargando información')

      setPresupuestosDatos([])

      PresupuestoService.obtenerxDatoNivel1AsInfoAsignacionPresupuesto(formData.datoPresupuestoNivel1)
        .then(({ data }) => {
          setTimeout(() => {
            setKeyTabla(IdGen.newId())
            setPresupuestosDatos(data)
            __zariContext.loader.close()
          }, 1000)
        })
        .catch(({ data: { error } }) => {
          setPresupuestosDatos([])
          __zariContext.snack('error', error)
          __zariContext.loader.close()
        })
        .finally(() => {
          setSubmitting(false)
        })

      setSubmitting(false)
    },
    [__zariContext]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Presupuestos - Asignacion' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Formik
            innerRef={formikRef}
            initialValues={formInitialValues}
            validationSchema={ValidationSchema}
            onSubmit={onSubmit}
          >
            {({ errors, touched, isSubmitting, handleSubmit, setFieldValue, handleChange }) => (
              <>
                <Row>
                  <Col md={3}>
                    <FormGroups.ProyectoFormGroup
                      iError={errors._idProyecto}
                      iTouched={touched._idProyecto}
                      fIsSubmitting={isSubmitting}
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                    />
                  </Col>
                  <Col md={2}>
                    <FormGroups.MonedaFormGroup iError={errors.moneda} iTouched={touched.moneda} />
                  </Col>
                  <Col md={3}>
                    <FormGroups.DatoPresupuestoNivel1FormGroup
                      iError={errors.datoPresupuestoNivel1}
                      iTouched={touched.datoPresupuestoNivel1}
                      fIsSubmitting={isSubmitting}
                    />
                  </Col>
                  <Col md={2}>
                    <FormGroups.AnoDesdeFormGroup
                      iError={errors.anoDesde}
                      iTouched={touched.anoDesde}
                      fIsSubmitting={isSubmitting}
                    />
                  </Col>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label text='&nbsp;' md={12} />
                      <Col md={12}>
                        <Button block onClick={handleSubmit}>
                          Consultar
                        </Button>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}
          </Formik>
        </Portlet.Body>
      </Portlet>
      {presupuestosDatos.length !== 0 && (
        <>
          <Tables.MainTable
            key={__keyTabla}
            presupuestosDatos={presupuestosDatos}
            idProyecto={formikRef.current.values._idProyecto}
            anoDesde={formikRef.current.values.anoDesde}
            datoNivel1={formikRef.current.values.datoPresupuestoNivel1}
          />
        </>
      )}
    </>
  )
}

export default React.memo(MainPage)
